module.exports = __webpack_public_path__ + "img/rightArrow.77e37c87.svg";